import React from "react";
import "./Landing.css";
import { findBySlug } from "../Shared/Seo/routeSeo.ts";
import { Seo } from "../Shared/Seo/Seo.tsx";
import { MathFactsGenerator } from "../MathFactsGenerator/MathFactsGenerator.tsx";
import { worksheetgeneratorSettings } from "../MathFactsGenerator/RouteSettings.ts";
import { DefaultSettings } from "../MathFactsGenerator/Models.ts";

/**
 * SEO landing-page template. Looks up its content by canonical slug in the
 * shared manifest (src/Shared/Seo/routeSeo.json), renders the single <h1> +
 * intro copy and an FAQ section, and embeds the existing generator (with its
 * own heading/Seo suppressed via embedded). The same manifest entry is baked
 * into the static HTML at build time by scripts/prerender.js.
 */
export function LandingPage({ slug }) {
    const entry = findBySlug(slug);

    if (!entry || !entry.operation) {
        return <MathFactsGenerator initialSettings={DefaultSettings} />;
    }

    const initialSettings = worksheetgeneratorSettings(entry.operation, entry.wordProblems);

    return (
        <>
            <Seo entry={entry} />
            <div className="landingContent">
                <h1>{entry.h1}</h1>
                {entry.intro?.map((paragraph, i) => (
                    <p key={i}>{paragraph}</p>
                ))}
            </div>

            <MathFactsGenerator initialSettings={initialSettings} embedded={true} />

            {entry.faq && entry.faq.length > 0 && (
                <section className="landingFaq">
                    <h2>Frequently asked questions</h2>
                    {entry.faq.map((item, i) => (
                        <div key={i} className="faqItem">
                            <h3>{item.q}</h3>
                            <p>{item.a}</p>
                        </div>
                    ))}
                </section>
            )}
        </>
    );
}

export default LandingPage;
